import { useScroll } from "framer-motion";
import Experience from "./components/Experience";
import Navbar from "./components/Navbar";
import JourneyRail from "./components/JourneyRail";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import TechStack from "./components/TechStack";
import Projects from "./components/Projects";
import YouTubeSection from "./components/YouTubeSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  const { scrollYProgress } = useScroll();

  return (
    <div className="App" style={{ position: "relative" }}>
      <Experience progress={scrollYProgress} />
      <Navbar />
      <JourneyRail />
      <main style={{ position: "relative", zIndex: 1 }}>
        <Hero />
        <About />
        <Services />
        <TechStack />
        <Projects />
        <YouTubeSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
